import { memo } from 'react';

import { DualTime } from '../DualTime/DualTime';
import { cn } from '../lib/utils';

export interface DualTimeRangeProps {
  startDateTime: Date;
  endDateTime: Date;
  memberTZ?: string | null;
  showWeekday?: boolean;
  showTime?: boolean;
  primaryTimeZone?: 'viewer' | 'member';
  className?: string;
}

function DualTimeRange({
  startDateTime,
  endDateTime,
  memberTZ,
  showWeekday = true,
  showTime = false,
  primaryTimeZone = 'member',
  className
}: DualTimeRangeProps) {
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <DualTime
        dateTime={startDateTime}
        memberTZ={memberTZ}
        showWeekday={showWeekday}
        showTime={showTime}
        primaryTimeZone={primaryTimeZone}
      />
      <span>-</span>
      <DualTime
        dateTime={endDateTime}
        memberTZ={memberTZ}
        showWeekday={showWeekday}
        showTime={showTime}
        primaryTimeZone={primaryTimeZone}
      />
    </span>
  );
}

export default memo(DualTimeRange);
export { DualTimeRange };
